import React, { useState } from "react";
import styled from "styled-components";
import CardIcon from "../../../resources/CardIcon";
import DeleteCard from "../../../resources/images/nftf/cardList/deleteCard.svg";

export const CardListErr = (props) => {
  const {
    manageMode,
    cardInfo,
    setCardInfo,
    selectCardData,
    idx,
    handleConfirmDialog,
    checkedOption,
  } = props;

  const [active, setActive] = useState(
    selectCardData ? (selectCardData.seqNo == cardInfo.seqNo ? true : false) : checkedOption
  );

  const toggleEvent = () => {
    // setCardInfo(cardInfo);
    alert("사용이 불가한 카드입니다.");
  };

  return (
    <Warapper disabledStatus={cardInfo.errChkYn === "Y" ? true : false}>
      <input
        type={"checkbox"}
        name="cardList"
        id={"cardList" + cardInfo.seqNo}
        onClick={() =>
          manageMode
            ? handleConfirmDialog("", "선택한 카드를 삭제하시겠습니까?", cardInfo.seqNo)
            : toggleEvent()
        }
        defaultChecked={active}
        hidden
      />
      <ListDiv htmlFor={"cardList" + cardInfo.seqNo}>
        <div>
          <CardIcon cardInfo={cardInfo} />
        </div>
        <div>
          <CardName
            // disabledStatus={true}
            active={false}
          >
            {cardInfo.cardNm}
          </CardName>
          <div style={{ display: "flex", gap: "8px" }}>
            <CardNum active={false}>{cardInfo.cardNo}</CardNum>

            {cardInfo.errChkYn === "Y" && <CardErr active={false}>결제실패</CardErr>}
          </div>
        </div>
        {manageMode && <img src={DeleteCard} style={{ marginLeft: "auto" }} />}
        <CardErrMsgDiv>{cardInfo.cardRsltMsg}</CardErrMsgDiv>
      </ListDiv>
    </Warapper>
  );
};

const CardErrMsgDiv = styled.div`
  display: flex;
  width: 288px;
  padding: 8px 16px;
  align-items: flex-start;
  gap: 10px;
  border-radius: 6px;
  background: #fafafa;
  color: #888;
  font-family: Pretendard;
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: 20px; /* 166.667% */
`;

// 결제카드 START
export const Warapper = styled.div`
  width: 100%;
  border-radius: 10px;
  background: ${(props) => (props.disabledStatus ? "#F0F0F0" : "#fafafa")};
  input[type="radio"]:checked + label {
    background-color: #6a62e6 !important;
  }
`;

export const ListDiv = styled.label`
  display: flex;
  flex-wrap: wrap;
  padding: 20px 16px;
  align-items: center;
  gap: 8px;
  align-self: stretch;
  border-radius: 10px;
  // background: ${(props) => (props.active ? "#6A62E6" : "#fafafa")};
`;

export const CardName = styled.div`
  color: ${(props) => (props.disabledStatus ? "#888" : props.active ? "#FFF" : "#333")};
  font-family: Pretendard;
  font-size: 14px;
  font-style: normal;
  font-weight: 600;
  line-height: 20px; /* 142.857% */
`;

export const CardNum = styled.div`
  color: ${(props) => (props.disabledStatus ? "#888" : props.active ? "#EEE" : "#888")};
  font-family: Pretendard;
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: 20px; /* 166.667% */
`;

export const CardErr = styled.div`
  color: #ff6259;
  font-family: Pretendard;
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: 20px; /* 166.667% */
`;
// 결제카드 END
